import has from 'lodash/has';
import get from 'lodash/get';
import { getStorageKeyData, postNativeMessage, checkIfPAApp } from 'utils';
import queryString from 'query-string';
import { REDUX_STORE, cookieKey } from 'assets/Constants';
import { openInNewTabOnAllBrowsers } from './deviceUtils';

export const getImageSrc = (path = '', isPrivate = true) => {
  try {
    const uri = '/api/contentservice';
    const proxyUri = `${window.appPath}proxy/ast/${isPrivate ? 'pa' : 'ga'}`;
    const src = `${proxyUri}${path.slice(uri.length)}`;
    return src;
  } catch (e) {
    console.error(e);
  }
};

export const getDirectSrc = (path = '') => {
  try {
    return 'https://assets.mfine.co' + (path.charAt(0) === '/' ? path : `/${path}`);
  } catch (e) {
    console.error(e);
  }
};

export const calculateWidth = size => {
  const sSize = '((100% - 3em) * 1/3)';
  if (size === 's') {
    return `calc(${sSize})`;
  } else if (size === 'm') {
    return `calc(${sSize} * 2 + 1em)`;
  } else {
    return `calc(100% - 1em)`;
  }
};

export const updateUrlParameter = (urlString, paramJson) => {
  if (typeof paramJson === 'object') {
    Object.keys(paramJson).forEach(paramName => {
      const paramValue = paramJson[paramName] ? paramJson[paramName] : '';
      const queryPattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
      if (urlString.search(queryPattern) >= 0 && paramValue) {
        urlString = urlString.replace(queryPattern, '$1' + paramValue + '$2');
      }
      urlString = urlString.replace(/[?#]$/, '');
    });
  }
  return urlString;
};

export const getURLParams = () => {
  try {
    const searchParams = window.location.search;
    return queryString.parse(searchParams);
  } catch (error) {
    console.error('Error in getting URL Params ::', error);
  }
};

export const capitalizeFirstLetter = string => {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
};

export const removeLeadingTrailingSpaces = string => {
  return string.trim();
};

const escapeRegExp = string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const replaceAll = (str, term, replacement) => {
  return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
};

export const getUniqueGuestName = (lengthOfName = 10) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'; //possible characters in name
  const charactersLength = characters.length;
  for (var i = 0; i < lengthOfName; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  result = 'guest-' + result;
  return result;
};

const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getUniqueGender = () => {
  const uniqueNo = getRandomNumber(1, 2);
  const genderConfig = {
    1: 'Male',
    2: 'Female',
  };
  const gender = genderConfig[uniqueNo] || 'Male';
  return gender;
};

export const getUniqueAge = () => {
  const maxAge = 60;
  const minAge = 20;
  const uniqueAge = getRandomNumber(minAge, maxAge);
  return uniqueAge;
};

export const CHANNEL = {
  PAYTM: 'paytm_mini_app',
  FLIPKART: 'flipkart',
  GPAY: 'gpay',
  PHONEPE: 'phonepe',
};
//get all Channel code
export const getValidChannelCode = () => {
  const validChannelArr = Object.keys(CHANNEL).map(key => CHANNEL[key]);
  return validChannelArr;
};
export const isValidChannelCode = channelCode => {
  const codes = getValidChannelCode();
  return codes.indexOf(channelCode) > -1;
};

export const CHANNEL_CONFIG = {
  [CHANNEL.GPAY]: {
    initiateSSO: true,
  },
  [CHANNEL.FLIPKART]: {
    initiateSSO: true,
  },
};
export const setWindowObjects = (appPath = '/', analyticsAppName, platform = '') => {
  try {
    window.appPath = appPath;
    window.analyticsAppName = analyticsAppName;
    window.platform = platform;
  } catch (error) {
    console.error('Error in setWindowObjects ::', error);
  }
};
export const getUserDetails = () => {
  const userId =
    (!!getStorageKeyData(cookieKey) && getStorageKeyData(cookieKey).split('%26%26%26%26')[0]) ||
    (!!getStorageKeyData(cookieKey) && getStorageKeyData(cookieKey).split('%26%26%26%26')[0]);
  if (userId) return { isLoggedIn: true, userId: userId };
  return { isLoggedIn: false };
};

export const getReferrer = () => {
  try {
    return document.referrer;
  } catch (error) {
    console.error('Error in fetching page referrer ::', error);
  }
};

export const extractUTMKeys = () => {
  const utmSourceLS = localStorage.getItem('utm_source');
  const utmMediumLS = localStorage.getItem('utm_medium');
  const utmCampaignLS = localStorage.getItem('utm_campaign');
  const params = getURLParams();
  const utmSourceURL = get(params, 'utm_source', '');
  const utmMediumURL = get(params, 'utm_medium', '');
  const utmCampaignURL = get(params, 'utm_campaign', '');
  return {
    utmSource: utmSourceURL || utmSourceLS,
    utmMedium: utmMediumURL || utmMediumLS,
    utmCampaign: utmCampaignURL || utmCampaignLS,
  };
};

export const getChannelId = () => {
  try {
    const channelId = localStorage.getItem('x-channel-id');
    if (channelId) {
      return channelId;
    }
    return '';
  } catch (error) {
    console.error('Error in getting channel id ::', error);
  }
};

export const setWindowObjectKey = (key, value) => {
  try {
    window[key] = value;
  } catch (error) {
    console.error(`Error while setting ${key} ::`, error);
  }
};

export const setGlobalParams = (appPath = '/assessment/') => {
  try {
    window.appPath = appPath;
    window.analyticsAppName = 'ASSESSMENT';
    window.platform = 'Web';
  } catch (error) {
    console.error('Error in Setting params ::', error);
  }
};

export const checkForStaleStore = () => {
  try {
    const localStorageKey = `persist:${REDUX_STORE.PERSIST_STORE_NAME}`;
    const localStorageExpiryKey = `persist:${REDUX_STORE.PERSIST_EXPIRY_NAME}`;
    const reduxExpiryTime = localStorage.getItem(localStorageExpiryKey);
    const now = new Date();
    const currentTime = now.getTime();

    const setNewExpiry = () => {
      const newExpiry = currentTime + REDUX_STORE.PERSIST_EXPIRY_DURATION;
      localStorage.setItem(localStorageExpiryKey, newExpiry);
    };

    if (reduxExpiryTime) {
      let parsedVal = parseInt(reduxExpiryTime);
      if (currentTime > parsedVal) {
        localStorage.removeItem(localStorageKey);
        localStorage.removeItem(localStorageExpiryKey);
        setNewExpiry();
      }
    } else {
      setNewExpiry();
    }
  } catch (error) {
    console.error('Error in Store validity check ::', error);
  }
};

export const checkIfInDebugMode = () => {
  /**
   * Mode = DEBUG, prevents caching of configs, so that changes can be tested quickly
   */
  const urlParams = getURLParams();
  const hasModeKey = has(urlParams, 'mode');
  if (hasModeKey) {
    const modeValue = get(urlParams, 'mode');
    return modeValue === 'debug';
  }
  return false;
};

export const handlePAAppCloseBtn = (isButtonVisible = false) => {
  const isPAApp = checkIfPAApp();
  if (isPAApp) {
    const event = {
      type: 'CLOSE_BTN',
      payload: { isVisible: !isButtonVisible },
    };
    postNativeMessage(event);
  }
};

export const setCurrentPage = pageName => {
  window.pageName = pageName;
};

export const getReplacedTextPhrases = (configArr = [], data = {}, forSkincare = false) => {
  if (Array.isArray(configArr)) {
    let usableConfigArr = configArr.map(item => item);
    if (!data?.primaryConcern) {
      usableConfigArr = configArr.filter(
        item => !['#{primaryConcern}#', '#{primaryConcernType}#.', '-'].includes(item?.phrase)
      );
      if (forSkincare) {
        const primaryConcernConfigObjArr = configArr.filter(
          item => item?.phrase === '#{primaryConcern}#'
        );

        if (primaryConcernConfigObjArr?.length) {
          usableConfigArr.push({
            phrase: 'No Skin Concern.',
            styles: primaryConcernConfigObjArr[0]?.styles || {
              color: '#F26E8E',
              fontFamily: 'Poppins',
              fontSize: '16px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0em',
              textAlign: 'left',
              display: 'inline',
              marginRight: '0.2em',
            },
          });
        }
      }
    } else if (!data?.primaryConcernType) {
      usableConfigArr = configArr.filter(
        item => !['#{primaryConcernType}#.', '-'].includes(item?.phrase)
      );
    }

    return usableConfigArr.map(config => ({
      ...config,
      phrase: config?.phrase?.replace(config?.replaceKey, data[config?.dataKey] || ''),
    }));
  } else {
    console.error('Input not array!');
    return [];
  }
};

const getReplacedParams = (paramNames = [], url = '', data = {}) => {
  let updatedUrl = url;
  paramNames.forEach(paramName => {
    const strippedParamName = paramName
      .replace('$', '')
      .replace('{', '')
      .replace('}', '');

    updatedUrl = updatedUrl.replace(paramName, data[strippedParamName]);
  });

  return updatedUrl;
};

export const handleRedirect = ({ redirectUrl, redirectContext, windowRef = null }) => {
  const isPAApp = checkIfPAApp();
  switch (redirectUrl) {
    case 'APP_REDIRECTION':
      if (isPAApp) {
        const routeContext = get(redirectContext, 'context', {});
        const routeConfig = {
          targeturl: redirectContext.targeturl,
          replaceParams: redirectContext.replaceParams,
          targeturltype: redirectContext.targeturltype,
        };
        if (routeConfig?.replaceParams?.length) {
          const replacedParamsInUrl = getReplacedParams(
            routeConfig?.replaceParams,
            routeConfig?.targeturl,
            routeContext
          );
          routeConfig.targeturl = replacedParamsInUrl;
        }

        delete routeConfig?.replaceParams;
        const event = {
          type: 'ROUTE_TO',
          payload: {
            ...routeConfig,
            context: {
              ...routeContext,
              // sourceId: caseId,
              // sourceType: 'CASE',
              // referrer: report?.context?.assessmentName || '',
            },
          },
        };
        postNativeMessage(event);
      } else {
        const routeContext = get(redirectContext, 'context', {});
        const routeConfig = {
          targeturl: redirectContext.targeturl,
          replaceParams: redirectContext.replaceParams,
          targeturltype: redirectContext.targeturltype,
        };
        let windowRedirectUrl = '';
        const hostname = window.location.hostname || '';
        const _origin = ['', 'localhost'].includes(hostname)
          ? 'https://qawp.mfine.co'
          : window.location.origin;
        if (routeConfig?.replaceParams?.length) {
          const replacedParamsInUrl = getReplacedParams(
            routeConfig?.replaceParams,
            routeConfig?.targeturl,
            routeContext
          );
          routeConfig.targeturl = replacedParamsInUrl;
        }

        delete routeConfig?.replaceParams;
        windowRedirectUrl = `${_origin}${routeConfig.targeturl}`;
        if (`${routeConfig?.targeturltype}`.toLowerCase() !== 'web') {
          console.error('Unable to redirect');
        } else {
          let windowReference = windowRef;
          if (!windowReference) {
            windowReference = window.open();
          }
          openInNewTabOnAllBrowsers(windowRedirectUrl, windowReference);
        }
      }
      break;

    default:
      break;
  }
};

export const resolveAssessmentListData = assessmentList => {
  const baseUrl = window.location.origin + '/assessment/skincare/report';
  assessmentList.forEach(assessment => {
    const params = `?rs=${assessment.score}&channel=website&uid=${assessment.userId}&sp=${assessment.profileId}&caseId=${assessment.caseId}`;
    assessment['title'] = assessment['profileName'] + "'s " + assessment['assessmentTitle'];
    assessment['reportUrl'] = baseUrl + params;
    delete assessment['ctas'];
    delete assessment['inference'];
  });
  return assessmentList;
};

export const reportPageRedirection = slug => {
  const baseUrl = window.location.origin;
  window.location.href = baseUrl + '/assessment/' + slug + '/web';
};

export const loginPageRedirection = () => {
  const loginUrl = window.location.origin + '/consult/login?referrer=' + window.location.href;
  window.location.href = loginUrl;
};
